﻿export default function (value) {
    if (value == 0) {
        return 'Студия';
    }
    else {
        return `${value} комн.`;
    }   
}